module.exports = __webpack_public_path__ + "img/logo-topresume.svg?version=1d7d1318";